export const FeatureNameEnum = {
    MEASUREMENT: 'Measurement',
    ANNOTATION: 'Annotation',
    INFORMATION_ANNOTATION: 'InformationAnnotation',
    MEDIA_SCREEN: 'MediaScreen',
    SELECTION: 'Selection',
    ENVIRONMENT: 'Environment',
    USER_MANAGER: 'UserManager',
    MEETING: 'Meeting',
    MOVE_AND_ROTATE: 'MoveAndRotate',
    SCREEN_SHOT: 'ScreenShot',
    EXPLOSION: 'Explosion',
    _360_VIDEO: '360Video',
    _360_IMAGE: '360Image',
    AUDIO: 'Audio',
    CABLE: 'Cable',
    CLIP_PLANE: 'ClipPlane',
    FLOOR: 'Floor',
    SESSION: 'Session',
    DRAW: 'Draw',
    WHITE_BOARD: 'WhiteBoard'
};